//# sourceMappingURL=arrow_down_line.mjs.map
/// <reference types="./arrow_down_line.d.mts" />
import * as $attribute from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $svg from "../../ds/internals/svg.mjs";
import { toList } from "../../gleam.mjs";

export function arrow_down_line() {
  return $svg.square_(
    20,
    toList([$attribute.style(toList([["transform", "rotate(180deg)"]]))]),
    "<path d=\"M9.99999 9.64854L5.87499 13.7735L4.69666 12.5952L9.99999 7.29187L15.3033 12.5952L14.125 13.7735L9.99999 9.64854Z\" fill=\"currentColor\"/>",
  );
}
